import NotificationService from '../../services/NotificationService';
import notificationUseCase from './notificationUseCase';

const notificationFactory = notificationUseCase({
  NotificationService: NotificationService(),
});

export default notificationFactory;
